import { render, staticRenderFns } from "./OxxoInstructionsModal.vue?vue&type=template&id=a1d55e28&scoped=true&"
import script from "./OxxoInstructionsModal.vue?vue&type=script&lang=js&"
export * from "./OxxoInstructionsModal.vue?vue&type=script&lang=js&"
import style0 from "./OxxoInstructionsModal.vue?vue&type=style&index=0&id=a1d55e28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d55e28",
  null
  
)

export default component.exports